<template>
    <header class="cabecera bg-primary">
        <div class="container">
            <div class="row">
                <div class="col barra">
                    <div class="float-left der-icon">
                        <router-link tag="div" class="centro kia align-middle" :to="{ name: 'p1'}">
                            <img src="@/assets/images/Logo-Kia.png" alt="LOGO KIA" class="img-fluid logo-main p-3">
                        </router-link>
                    </div>
                    <div class="float-right der-icon">
                        <div class="centro align-middle ">
                            <div class="col animated fadeIn pt-2" v-if="mstOnline">
                                <button class="btn btn-outline-light" type="button" v-b-modal.login v-if="!logeado"><span class="fa fa-user"></span> Iniciar sesión</button>
                                <template v-else>
                                    <router-link tag="button" :to="{name:'cotizaciones'}" class="btn btn-link text-white" type="button"><span class="far fa-user"></span> {{nombre}}</router-link>
                                    <button class="btn btn-link text-white" type="button" v-on:click="cerrar"><span class="fa fa-sign-out-alt"></span> Salir</button>
                                </template>
                            </div>
                            <div class="col animated fadeIn" v-else>
                                <button class="btn btn-light" v-on:click="irKia"><span class="fa fa-home"></span> Home</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal id="login" v-model="modal" hide-footer centered  hide-header title="Login" body-class="m-0 p-0">
            <div class="p-0">
                <div class="bg-primary text-center p-3">
                    <img src="@/assets/images/Logo-Kia.png" alt="Logo White" class="img-fluid logo-white p-1">
                    <h4 class="text-white">Compra on line</h4>
                </div>
                <div class="m-4 p-4 animated fadeIn" v-if="p===1">
                    <h5 class="text-primary">Iniciar sesión</h5>
                    <form @submit.prevent="validar('session')" data-vv-scope="session">
                        <div class="row">
                            <div class="form-group col-12">
                                <label for="númerodi">Número de identificación</label>
                                <input :disabled="procesando" type="tel" class="form-control form-control-sm" v-model="formulario.dt1" name="número de identificación" id="númerodi" v-validate="{required:true}" >
                                <span class="form-text text-danger">{{errors.first("session.número de identificación")}}</span>
                            </div>
                            <div class="form-group col-12">
                                <label for="contraseña">Contraseña</label>
                                <div class="kt-input-icon kt-input-icon--right">
                                    <input :disabled="procesando" :type="mostrar ? 'text' : 'password'" class="form-control form-control-sm" v-model="formulario.dt2" name="contraseña" id="contraseña" v-validate="{required:true}" >
                                    <span class="kt-input-icon__icon kt-input-icon__icon--right" v-on:mousedown="mostrar=true" v-on:mouseup="mostrar=false" v-on:mouseleave="mostrar=false">
                                        <span><i class="la" :class="mostrar ? 'la-eye' : 'la-eye-slash'"></i></span>
                                    </span>
                                </div>
                                <span class="form-text text-danger">{{errors.first("session.contraseña")}}</span>
                            </div>
                        </div>
                        <div class="row">
                            <button
                                    type="submit"
                                    class="btn btn-brand btn-elevate btn-pill btn-elevate-air btn-sm btn-block"
                                    :class="procesando ? 'kt-spinner kt-spinner--right kt-spinner--lg kt-spinner--light disabled' : ''"
                                    :disabled="procesando"
                            >
                                Iniciar sesión
                            </button>
                        </div>
                        <div class="row pt-4">
                            <div class="col-md-6"></div>
                            <div class="col-md-6">
                                <button class="btn btn-link" type="button" v-on:click="p=2">¿Olvidaste tu contraseña?</button>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="m-4 p-4 animated zoomIn" v-else>
                    <h5 class="text-primary"><button class="btn btn-link btn-sm pb-1 p-0"><i class="fa fa-arrow-left" v-on:click="p=1"></i></button>Olvidaste tu contraseña</h5>
                    <form @submit.prevent="validar('olvido')" data-vv-scope="olvido">
                        <div class="row">
                            <div class="form-group col-12">
                                <label for="númerodid"><i class="fa fa-asterisk text-danger"></i>Número de identificación</label>
                                <input :disabled="procesando" type="tel" class="form-control form-control-sm" v-model="formulario.dt1" name="número de identificación" id="númerodid" v-validate="{required:true,ci:true}" >
                                <span class="form-text text-danger">{{errors.first("olvido.número de identificación")}}</span>
                            </div>
                        </div>
                        <div class="row">
                            <button
                                    type="submit"
                                    class="btn btn-brand btn-elevate btn-pill btn-elevate-air btn-sm btn-block"
                                    :class="procesando ? 'kt-spinner kt-spinner--right kt-spinner--lg kt-spinner--light disabled' : ''"
                                    :disabled="procesando"
                            >
                                Enviar
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </b-modal>
    </header>
</template>

<script>
    import constantes from "../constantes";
    import _ from 'lodash';
    import {auth} from "../servicios";

    export default {
        name: "Header",
        data:()=>({
            formulario:{
                dt1:null,
                dt2:null,
            },
            procesando:false,
            modal:false,
            mostrar:false,
            p:1
        }),
        props:{
            botonHome:{
                type:Boolean,
                default:false,
            }
        },
        methods:{
            cerrar:function(){
                this.$swal({
                    title: 'Salir',
                    html: '<b>¿Estas seguro que quieres Cerrar Sesión?</b>',
                    showLoaderOnConfirm: true,
                    showSpinner: true,
                    showCancelButton: true,
                    confirmButtonText: 'Si',
                    confirmButtonAriaLabel: 'No',
                    cancelButtonText: 'No',
                    cancelButtonAriaLabel: 'Si',
                    preConfirm: (aux) => {
                        return this.$store.dispatch('cerrarSesion',this.formulario).then(()=>{
                            this.$router.push({name:'p1'});
                            return aux;
                        });
                    }
                });
            },
            irKia:function(){
                window.open(process.env.VUE_APP_URL_COMPANY, '_blank');
            },
            afterIniciarSesion:function(response){
                this.procesando=false;
                this.modal=false;
                this.$toast.info(`Iniciaste sesión como ${response.dt96}`);
                setTimeout(()=>{
                    this.$router.push({name:'cotizaciones'});
                },500);
            },
            iniciarSession:function(){
                this.$store.dispatch('sesionU',this.formulario).then((response)=>{
                  if (response.status === 202) {
                    this.preguntaValidacion(response.data);
                  } else {
                    this.afterIniciarSesion(response);
                  }
                }).catch((error)=>{
                    if(error.response.data.dt1===constantes.Constantes.enumeraciones.sesionActiva){
                        this.$swal({
                            title: error.response.data.dt1,
                            html: '<b>¿Desea cerrarla?</b>',
                            showLoaderOnConfirm: true,
                            showSpinner: true,
                            showCancelButton: true,
                            confirmButtonText: 'Si',
                            confirmButtonAriaLabel: 'No',
                            cancelButtonText: 'No',
                            cancelButtonAriaLabel: 'Si',
                            preConfirm: (aux) => {
                                return this.$store.dispatch('cerrarSesion',this.formulario).then(()=>{
                                    return this.$store.dispatch('sesionU',this.formulario).then((response)=>{
                                        this.afterIniciarSesion(response);
                                        return aux;
                                    }).catch(()=>{
                                        this.formulario.dt2=null;
                                        return aux;
                                    });
                                });
                            }
                        });
                    }else{
                        this.formulario.dt2=null;
                    }
                    this.procesando=false;
                });
            },
            validar:function(scope){
                this.$validator.validateAll(scope).then((result) => {
                    if(result){
                        this.procesando=true;
                        if(this.p===1)
                            this.iniciarSession();
                        if(this.p===2)
                            this.olvidoContrasena();
                    }else{
                        this.$toast.show(`Completa el formulario`);
                    }
                });
            },
            olvidoContrasena:function(){
                auth.olvidoPws(this.formulario).then(()=>{
                    this.procesando=false;
                    this.formulario.dt1=null;
                    this.formulario.dt2=null;
                    this.p=1;
                    this.$toast.info(`Se ha enviado un correo electrónico y un SMS con una nueva contraseña de acceso`);
                }).catch(()=>{
                    setTimeout(()=>{
                        this.procesando=false;
                    },8000);
                })
            },
          preguntaValidacion (response) {
            this.modal=false;
            this.$swal({
              title: 'Validación de Usuario',
              html: '<b>¿Quieres generar un nuevo código de verificación único (OTP) para tu cuenta?</b>',
              icon: 'question',
              showCancelButton: true,
              allowEscapeKey: false,
              confirmButtonText: 'Si, enviarme',
              confirmButtonAriaLabel: 'Si',
              cancelButtonText: 'No, enviarme',
              cancelButtonAriaLabel: 'No',
              allowOutsideClick: false,
              showLoaderOnConfirm: true,
              preConfirm: () => {
                return auth.reenviarCode(response.ndt1).then(() => {
                  this.cargando = false;
                  setTimeout(()=>{
                    this.validacionSMS(response)
                  },500);
                  return response
                }).catch(() => {
                  this.cargando = false;
                  setTimeout(()=>{
                    this.validacionSMS(response)
                  },500);
                  return response
                })
              }
            }).then((result) => {
              if (result.dismiss === 'cancel') {
                this.modal=true;
                this.limpiarForm();
              }
            })
          },
          reenviarSMS: _.debounce(function (response) {
            auth.reenviarCode(response.ndt1).then(() => {
              this.cargando = false
              this.validacionSMS(response)
            }).catch(()=>{
              this.validacionSMS(response)
            })
          }, 2000),
          validacionSMS (response) {
            this.cargando = false
            this.$emit('input', false)
            this.$swal({
              title: 'Validación de Usuario',
              html: '<b>Un código de verificación único (OTP) ha sido enviado a tu celular como SMS y a su dirección de correo electrónico. Para verificar su cuenta de usuario, por favor ingresa el código a continuación.</b>',
              input: 'text',
              inputAttributes: {
                autocapitalize: 'off'
              },
              inputValidator: (value) => {
                if (!value || value.length !== constantes.Constantes.lengthOTP) {
                  return 'Necesita ingresar un código OTP enviado a su Celular y a su Email'
                }
              },
              showLoaderOnConfirm: true,
              showCancelButton: true,
              confirmButtonText: 'Verificar',
              confirmButtonAriaLabel: 'Verificar',
              cancelButtonText: 'Reenviar OTP',
              cancelButtonAriaLabel: 'Reenviar OTP',
              allowOutsideClick: false,
              preConfirm: (texto) => {
                const dto = {
                  id: response.ndt1,
                  codigo: texto
                }
                return this.$store.dispatch('registerU', dto).then(() => {
                  setTimeout(() => {
                    this.$router.push({ name: 'usuario' })
                  }, 2000)
                  this.$toast.success('Validación Exitosa')
                  return texto
                }).catch(() => {
                  this.cargando = true
                  setTimeout(()=>{
                    this.validacionSMS(response);
                  },500);
                  // this.reenviarSMS(response)
                })
              }
            }).then((result) => {
              if (result.dismiss === 'cancel') {
                this.cargando = true
                this.reenviarSMS(response)
              }
            })
          },
          limpiarForm: function(){
            this.formulario.dt1=null;
            this.formulario.dt2=null;
            this.procesando = false;
          }
        },
        computed:{
            logeado:function(){
                return this.$store.getters.getUsuario.bdt;
            },
            estado:function(){
                return this.$store.getters.getPermiso;
            },
            nombre:function(){
                return this.$store.getters.getUsuario.dt96;
            },
            mstOnline:function(){
                if(this.botonHome)
                    return false;
                else
                    return process.env.VUE_APP_ONLINE === 'true';
            }
        }
    }
</script>

<style scoped>
    header{
        font-size: 10px;
      margin-top: -3px;
    }
    .kia{
        cursor: pointer;
    }
    .barra{
        margin-top: 10px;
        margin-bottom: 10px;

    }
    .der-icon{
        height: 100%;
    }
    .centro{
        margin-top: auto;
        margin-bottom: auto;
    }
    .logo-main{
        max-height: 50px;
    }
    .linea{
        -webkit-box-shadow: 0px 1px 9px 0px rgba(0,0,0,0.75);
        -moz-box-shadow: 0px 1px 9px 0px rgba(0,0,0,0.75);
        box-shadow: 0px 1px 9px 0px rgba(0,0,0,0.75);
    }
    .logo-white{
        max-height: 40px;
    }
    .kt-input-icon__icon{
        cursor: pointer;
    }
    .la{
        color: black;
    }
</style>
